export default "__VITE_ASSET__cc12c835__"